import application from 'application/application';

application

	.value('dataCache', {});
